import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LogoDarkNoBg from "../../assets/img/indak-logo-without-background.png";
import LogoLightNoBg from "../../assets/img/indak-logo-without-background2.png";
import { subscribeToRequestCount } from "../../utils/requestTracker";
import "./PageTransition.css";

export default function PageTransition() {
  const location = useLocation();
  const [displayPath, setDisplayPath] = useState(location.pathname);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [minTimePassed, setMinTimePassed] = useState(true);
  const [activeRequests, setActiveRequests] = useState(0);
  const [theme, setTheme] = useState(() => document.documentElement.getAttribute("data-theme") || "light");

  // Track active requests count
  useEffect(() => {
    return subscribeToRequestCount((count) => {
      setActiveRequests(count);
    });
  }, []);

  // Track document theme dynamically
  useEffect(() => {
    const checkTheme = () => {
      const activeTheme = document.documentElement.getAttribute("data-theme") || "light";
      setTheme(activeTheme);
    };

    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  // Trigger transition on path change
  useEffect(() => {
    if (location.pathname !== displayPath) {
      setIsTransitioning(true);
      setMinTimePassed(false);

      // Reset scroll position to top of page
      window.scrollTo(0, 0);

      const timer = setTimeout(() => {
        setMinTimePassed(true);
      }, 500); // 0.5s minimum loading duration

      return () => clearTimeout(timer);
    }
  }, [location.pathname, displayPath]);

  // End transition when minimum time has passed and all fetches are complete
  useEffect(() => {
    if (minTimePassed && activeRequests === 0 && isTransitioning) {
      setDisplayPath(location.pathname);
      setIsTransitioning(false);
    }
  }, [minTimePassed, activeRequests, isTransitioning, location.pathname]);

  // Instant calculation so overlay activates on frame 0 of route change (prevents page flash)
  const routeChanged = location.pathname !== displayPath;
  const showOverlay = isTransitioning || routeChanged;

  return (
    <div className={`page-transition-overlay ${showOverlay ? "active" : ""}`}>
      <div className="transition-container">
        {/* Logo Stage */}
        <div className="transition-logo-stage">
          <img 
            src={theme === "dark" ? LogoDarkNoBg : LogoLightNoBg} 
            alt="INDAK Logistics" 
            className="transition-logo-nobg" 
          />

          {/* Flying Airplane docking directly into logo */}
          <div className="airplane-flight-dock">
            <div className="airplane-trail"></div>
            <svg
              className="docking-plane-icon"
              viewBox="0 0 24 24"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
            </svg>
            <div className="dock-flash"></div>
          </div>
        </div>

        {/* Loading indicator */}
        <div className="transition-text">
          <span>Terbang Bersama INDAK</span>
          <div className="pulse-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
}
